import React from 'react';
import { connect } from 'react-redux';
import { gql } from 'apollo-boost';
import { Query } from 'react-apollo';
import Spinner from '~/components/spinner/spinner';
import HSCodeSummaryCard from '~/components/hsCodeSummaryCard/hsCodeSummaryCard';
import HSCodeProductListCard from '~/components/hsCodeProductListCard/hsCodeProductListCard';
import ErrorBoundaryContent from '~/components/errorBoundary/content';

export const getHSCodeQuery = gql`
  query hsCode($id: Int!) {
    hsCode(id: $id) {
      id
      name
      description
      products {
        id
        name
        beerStyle {
          id
          name
        }
      }
    }
  }
`;

const Ingredient = ({ onCompleted, id }) => (
  <Query query={getHSCodeQuery} variables={{ id }} onCompleted={onCompleted} fetchPolicy={'cache-and-network'}>
    {props => {
      const { loading, error, data } = props;
      if (loading) {
        return <Spinner className="absolute absolute-center stroke-brand-red" />;
      }

      if (error) {
        return <ErrorBoundaryContent error={error} />;
      }

      const { hsCode } = data;
      return (
        <div className="flex content">
          <div className="flex-2 mr4">
            <HSCodeProductListCard products={hsCode.products} />
          </div>
          <div className="flex-1">
            <HSCodeSummaryCard className="mb4" {...hsCode} />
          </div>
        </div>
      );
    }}
  </Query>
);

function mapStateToProps(state) {
  return {
    brewery: state.brewery
  };
}

export default connect(mapStateToProps)(Ingredient);



// WEBPACK FOOTER //
// ./src/containers/hsCode/hsCode.jsx